var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.276.072H.794a.774.774 0 00-.555.236.819.819 0 00-.23.571v10.494c0 .214.082.42.23.57a.774.774 0 00.555.237h16.482a.774.774 0 00.555-.236.819.819 0 00.23-.571V.879a.819.819 0 00-.23-.57.774.774 0 00-.555-.237zM2.363 3.301a.77.77 0 01-.436-.136.803.803 0 01-.289-.362.829.829 0 01.17-.88.765.765 0 01.855-.175.79.79 0 01.353.297.824.824 0 01-.098 1.02.774.774 0 01-.555.236zm6.672 5.247c-.466 0-.92-.142-1.308-.408a2.408 2.408 0 01-.867-1.087 2.486 2.486 0 01-.134-1.4c.09-.47.315-.9.644-1.24.33-.338.749-.569 1.206-.662.456-.093.93-.046 1.36.138.43.183.798.493 1.057.892.259.398.397.866.397 1.345 0 .642-.248 1.258-.69 1.712-.442.455-1.04.71-1.665.71zm6.672 2.018a.77.77 0 01-.437-.136.803.803 0 01-.289-.363.828.828 0 01.17-.88.765.765 0 01.855-.175.79.79 0 01.353.298.824.824 0 01-.097 1.02.774.774 0 01-.555.236z",
    fill: "#8C92A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.d2648a184d1f48c7023b147f48a6a33f.svg";
export { ForwardRef as ReactComponent };